export const validateForm = (formData: any): Record<string, string> => {
  const errors: Record<string, string> = {};

  // Validar claim - máx 3 líneas
  if (formData.claim) {
    const lines = formData.claim.split('\n').filter((l: string) => l.trim().length > 0);
    if (lines.length > 3) {
      errors.claim = `El claim debe tener máximo 3 líneas (actualmente tiene ${lines.length})`;
    }
  }

  // Validar subheadline - máx 2 líneas
  if (formData.subheadline) {
    const lines = formData.subheadline.split('\n').filter((l: string) => l.trim().length > 0);
    if (lines.length > 2) {
      errors.subheadline = `La bajada debe tener máximo 2 líneas (actualmente tiene ${lines.length})`;
    }
  }

  // Validar highlighted_word_index contra el número de palabras en claim
  if (formData.claim && formData.highlighted_word_index) {
    const words = formData.claim
      .trim()
      .split(/\s+/)
      .filter((w: string) => w.length > 0);
    const wordCount = words.length;
    const index = parseInt(formData.highlighted_word_index);

    if (index < 1 || index > wordCount) {
      errors.highlighted_word_index = `El claim tiene ${wordCount} palabra${wordCount !== 1 ? 's' : ''}. Elegí un número entre 1 y ${wordCount}`;
    }
  }

  return errors;
};
